module.exports = __webpack_public_path__ + "img/09.55917a9c.png";